import {Component, OnInit, Inject} from '@angular/core';
import {FormGroup, FormControl, FormGroupDirective, NgForm, Validators, FormBuilder} from '@angular/forms';
import {ProductLotService} from 'src/app/services/product-lot.service';
import {ProductPriceService} from 'src/app/services/product-price.service';
import {MatTableDataSource, } from '@angular/material/table';
import {ErrorStateMatcher} from '@angular/material/core';
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import {ProductCatPriceService} from 'src/app/services/product-cat-price.service';
import {SubcategoryService} from 'src/app/services/subcategory.service';
import {CategoryPrice} from 'src/app/models/category-price';
import {SnackBarIconService} from 'src/app/shared/snack-bar-icon/snack-bar-icon.service';
import {ConfirmComponent} from 'src/app/shared/dialogs/confirm/confirm.component';
import {ProductDocPriceDialogComponent} from '../product-doc-price-dialog/product-doc-price-dialog.component';


export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-product-cat-price-dialog',
  templateUrl: './product-cat-price-dialog.component.html',
  styleUrls: [ './product-cat-price-dialog.component.scss' ],
})
export class ProductCatPriceDialogComponent implements OnInit {

  public matcher = new FormErrorStateMatcher();

  public priceForm: FormGroup;
  public entityForm: FormGroup;

  public isPartner: boolean;
  public currentCategoryPrice: CategoryPrice;
  public arraySubCategories: any[] = []

  public subCategorySelected: any = {}
  public subCategorySelected_id: any;

  public selectedSubCategoriesDataSource: MatTableDataSource<any>;
  public displayedCategoryPricesColumns: string[] = [ 'icon', 'name', 'delete' ];

  public isEdit: boolean;

  constructor (
    private fb: FormBuilder,
    public _productLotService: ProductLotService,
    public _productPriceService: ProductPriceService,
    public _productCatPriceService: ProductCatPriceService,
    public _subcategoryService: SubcategoryService,
    private snackBar: SnackBarIconService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit () {

    this.isPartner = this.data.isPartner;
    this.currentCategoryPrice = this.data.categoryPrice

    if (this.currentCategoryPrice.id) {
      this.isEdit = true;
    } else {
      this.isEdit = false;
    }

    this._productPriceService.currentProductLot = this.data.lot;

    this.priceForm = this.createCatPriceForm();
    this.entityForm = this.createForm();

    this.loadSubCategories(this.isPartner)

    //console.log(JSON.stringify(this.currentCategoryPrice))
    this.setFormValues(this.currentCategoryPrice, this.entityForm)

  }

  loadSubCategories (isPartner) {
    this._subcategoryService.selectSubcategories(this.isPartner)
      .subscribe((result) => {
        result.forEach((item) => {

          let cat = {
            'id': item.payload.doc.id,
            'name': item.payload.doc.data().name,
            'hidden': item.payload.doc.data().hidden,
            'partner': item.payload.doc.data().partner
          }

          this.arraySubCategories.push(cat)
        })

        //  console.log("----------------------------")
        //  console.log(JSON.stringify(this.arraySubCategories))

      })

  }

  createCatPriceForm () {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      lot_id: new FormControl(''),
      lot_name: new FormControl(''),
      category_id: new FormControl(''),
      category_name: new FormControl(''),
      /*
      value: new FormControl('', [ Validators.required ]),
      value_pix: new FormControl('', [ Validators.required ]),
      value_defaulting: new FormControl('', [ Validators.required ]),
      pix_discount: new FormControl('', [ Validators.required ])
      */
    });

    return form
  }

  selectCategory (event) {
    //  console.log("selectCategory: " + event)
    this.subCategorySelected_id = event

    this.subCategorySelected = this.arraySubCategories.find((e) => {
      return e.id == this.subCategorySelected_id
    })

  }

  addSubCategory () {
    this.currentCategoryPrice.categories.push(this.subCategorySelected)
    this.selectedSubCategoriesDataSource = new MatTableDataSource(this.currentCategoryPrice.categories)
  }

  removeSubCategory (element) {
    const id = element.id
    this.currentCategoryPrice.categories = this.currentCategoryPrice.categories.filter((e) => {
      return e.id != id
    })
    this.selectedSubCategoriesDataSource = new MatTableDataSource(this.currentCategoryPrice.categories)
  }

  insert () {

    //console.log("his.data.product: " + JSON.stringify(this.data.product))

    this.entityForm.controls.lot_id.setValue(this.data.lot.id);
    this.entityForm.controls.product_id.setValue(this.data.product.id);
    this.entityForm.controls.partner.setValue(this.data.isPartner);

    if (this.entityForm.valid) {

      let entity: CategoryPrice = this.createEntity(this.entityForm.value);
      //console.log("insert entity: " + JSON.stringify(entity))
      this._productCatPriceService.insert(entity)
        .then((result) => {
          // console.log("result: " + JSON.stringify(result))
          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        })
        .catch((error) => {
          console.log("error: " + JSON.stringify(error))
          this.snackBar.openSnackBar("Erro!", '', 'error');
        })

    }


  }

  update () {

    //console.log("update ------------------------- " + this.entityForm.valid)
    if (this.entityForm.valid) {
      let entity: CategoryPrice = this.createEntity(this.entityForm.value);

      //console.log("entity: " + JSON.stringify(entity))

      this._productCatPriceService.update(entity)
        .then((result) => {
          console.log("result: " + JSON.stringify(result))
          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        })
        .catch((error) => {
          console.log("error: " + JSON.stringify(error))
          this.snackBar.openSnackBar("Erro!", '', 'error');
        })

    }

  }

  createEntity (data: any): CategoryPrice {

    let entity = new CategoryPrice();

    entity.id = data.id;
    entity.name = data.name;
    entity.foreigners_only = data.foreigners_only ? data.foreigners_only : false;
    entity.lot_id = data.lot_id;
    entity.product_id = data.product_id;
    entity.requires_doc = data.requires_doc ? data.requires_doc : false;
    entity.list_doc = data.list_doc ? data.list_doc : "";
    entity.show_on_site = data.show_on_site ? data.show_on_site : false;
    entity.value = Number(data.value);
    entity.value_pix = Number(data.value_pix);
    entity.value_defaulting = data.value_defaulting ? Number(data.value_defaulting) : 0;
    entity.value_defaulting_pix = data.value_defaulting_pix ? Number(data.value_defaulting_pix) : 0;

    entity.pix_discount = data.pix_discount ? Number(data.pix_discount) : 0;

    entity.partner = data.partner ? data.partner : false;
    entity.categories = this.currentCategoryPrice.categories;

    entity.docList = this.currentCategoryPrice.docList ? this.currentCategoryPrice.docList : null;

    return entity;
  }


  createForm () {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      name: new FormControl('', [ Validators.required ]),
      requires_doc: new FormControl(''),
      list_doc: new FormControl(''),
      show_on_site: new FormControl(''),
      value: new FormControl('', [ Validators.required ]),
      value_pix: new FormControl('', [ Validators.required ]),
      value_defaulting: new FormControl(''),
      value_defaulting_pix: new FormControl(''),
      pix_discount: new FormControl(''),
      lot_id: new FormControl(''),
      product_id: new FormControl(''),
      partner: new FormControl(''),
      docList: new FormControl(''),
    });
    return form
  }

  setFormValues (data, form) {

    form.controls.id.setValue(data.id);
    form.controls.name.setValue(data.name);
    form.controls.requires_doc.setValue(data.requires_doc);
    form.controls.list_doc.setValue(data.list_doc);
    form.controls.show_on_site.setValue(data.show_on_site);
    form.controls.value.setValue(data.value);
    form.controls.value_pix.setValue(data.value_pix);
    form.controls.value_defaulting.setValue(data.value_defaulting);
    form.controls.value_defaulting_pix.setValue(data.value_defaulting_pix);
    form.controls.pix_discount.setValue(data.pix_discount);

    form.controls.lot_id.setValue(data.lot_id);
    form.controls.product_id.setValue(data.product_id);
    form.controls.partner.setValue(data.partner);

    form.controls.docList.setValue(data.docList);

    this.selectedSubCategoriesDataSource = new MatTableDataSource(this.currentCategoryPrice.categories)

  }


  openDocDialog (element: any) {

    let data: any = {}
    if (element) {
      data = element
    }

    let dialogRef = this.dialog.open(ProductDocPriceDialogComponent, {
      width: '600px',
      height: '350px',
      panelClass: 'custom-dialog-container',
      data: data,
    });

    dialogRef.afterClosed()
      .subscribe(response => {
        if (!response) {
          return;
        }

        const actionType: string = response[ 0 ];
        const form: FormGroup = response[ 1 ];

        let formData: any = form.getRawValue();
        if (actionType == 'insert') {
          const dt = new Date();
          const token = dt.getTime()
          const data = {
            id: token,
            doc: formData.doc
          }

          if (!this.currentCategoryPrice.docList) this.currentCategoryPrice.docList = [];

          this.currentCategoryPrice.docList.push(data)
          this.entityForm.controls.docList.setValue(this.currentCategoryPrice.docList);

          // console.log("this.data.docList: " + JSON.stringify(this.data.docList))

        } else if (actionType == 'update') {
          this.currentCategoryPrice.docList.forEach((item) => {
            if (item.id == formData.id) {
              item.doc = formData.doc;
            }
          })
          this.entityForm.controls.docList.setValue(this.data.docList);
        }
      })
  }

  removeDocument (id) {
    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: "<br><br>Excluir este documento?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {
        this.currentCategoryPrice.docList = this.currentCategoryPrice.docList.filter((e) => {
          return e.id !== id;
        })
        this.entityForm.controls.docList.setValue(this.currentCategoryPrice.docList);
      }
    })
  }

}
